import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import art1 from "assets/images/arts/art1.jpg"
import art2 from "assets/images/arts/art2.jpg"
import art3 from "assets/images/arts/art3.jpg"
import art4 from "assets/images/arts/art4.jpg"
// import art5 from "assets/images/arts/art5.jpg"
// import art6 from "assets/images/arts/art6.jpg"
import { Slide } from "react-reveal";

SwiperCore.use([Autoplay]);

const NftSlider = () => {
    const images = [
        art1,
        art2,
        art3,
        art4,
        // art5,
        // art6,
    ];
    return (
        <section id='nft'>
            <div className="container">
                <div className="row">
                    <div className="sec-heading-wrapper">
                    <Slide bottom>    
                    <h1 className="sec-heading">First reveals</h1>
                    </Slide> 
                    </div>
                </div>
            </div>
            <div>
                <Swiper
                    autoplay={{ disableOnInteraction: false, delay: 1500 }}
                    className="nft-slide-container"
                    speed={500}
                    spaceBetween={75}
                    slidesPerView={3}
                    centeredSlides
                    loop={true}
                    breakpoints={{
                        190: {
                            slidesPerView: 1,
                            spaceBetween: 15
                        },
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                        992: {
                            slidesPerView: 3,
                        },
                        1700: {
                            slidesPerView: 4,
                        },
                        1800: {
                            slidesPerView: 5,
                        },
                        2200: {
                            slidesPerView: 5,
                        },
                        2800: {
                            slidesPerView: 6,
                        },
                    }}
                >
                   {images.map((imgItem, index) => (
                    <SwiperSlide key={index} className="nft-slide">
                        <img loading="lazy" className="nft-art-img" src={imgItem} alt="Meta Masks NFT" />
                    </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}

export default NftSlider
